<template>
  <div class="hiq-detail-planning-list__selected-filters-wrapper">
    <button
      class="hiq-detail-planning-list__selected-filters-clear-button"
      v-if="selectedFilters.length > 0"
      @click="deselectAllFilters"
    >
      {{ translations.clearAllFilters }}
    </button>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { deselectAllFilters } from "../store/actions";
import { IFilter, ITranslations } from "../store/state";

interface SelectedFiltersComputed {
  selectedFilters: IFilter[];
  translations: ITranslations;
}
interface SelectedFiltersMethods {
  deselectAllFilters(): void;
}

export default Vue.extend<
  {},
  SelectedFiltersMethods,
  SelectedFiltersComputed,
  {}
>({
  name: "SelectedFilters",
  computed: {
    selectedFilters() {
      return [
        ...this.$store.getters.areaFilter,
        ...this.$store.getters.statusFilter,
      ].filter((filter: IFilter) => filter.selected);
    },
    translations() {
      return this.$store.getters.translations;
    },
  },
  methods: {
    deselectAllFilters() {
      this.$store.dispatch(deselectAllFilters(undefined));
    },
  },
});
</script>
